/*
 * Public API Surface of make-a-vis
 */
export * from './lib/make-a-vis.component';
export * from './lib/make-a-vis.module';
